import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { toast } from "sonner";

// Suivi « carte à réenregistrer » (ex. Dave Veillette) — lecture live Stripe + relance SMS (clic) + relance auto préparée le 3 oct.
export function CardFollowups() {
  const [rows, setRows] = useState(null);
  const [busy, setBusy] = useState("");
  const [preview, setPreview] = useState(null);
  const load = () => api.get("/billing/card-followups").then((r) => setRows(r.data.followups)).catch(() => setRows([]));
  useEffect(() => { load(); }, []);
  const remind = async (f, channel) => {
    if (channel === "sms" && !window.confirm(`Envoyer maintenant un SMS de relance à ${f.name} (${f.phone}) avec un nouveau lien Stripe (24 h) ?`)) return;
    setBusy(f.id + channel);
    try {
      const r = await api.post(`/billing/card-followups/${f.id}/remind`, { channel });
      if (channel === "preview") setPreview({ name: f.name, text: r.data.text });
      else { toast.success(`SMS envoyé à ${f.name}`); load(); }
    } catch (e) { toast.error(e?.response?.data?.detail || "Erreur"); } finally { setBusy(""); }
  };
  if (!rows) return <p className="text-zinc-500 text-sm" data-testid="card-followups-loading">Vérification des cartes dans Stripe…</p>;
  if (!rows.length) return null;
  return (
    <div className="rounded-xl border border-zinc-800 bg-zinc-900/50 p-4 space-y-3" data-testid="card-followups">
      <h4 className="font-semibold text-zinc-100 text-sm">💳 Suivi — carte à réenregistrer</h4>
      {rows.map((f) => (
        <div key={f.id} className={`rounded-lg border p-3 text-sm ${f.done ? "border-emerald-700/50 bg-emerald-950/30" : f.overdue ? "border-rose-600/60 bg-rose-950/30" : "border-amber-500/50 bg-amber-950/20"}`} data-testid={`card-followup-${f.id}`}>
          <div className="flex flex-wrap items-center justify-between gap-2">
            <div>
              <p className="font-semibold text-zinc-100">{f.name} <span className="text-zinc-500 text-xs">· {f.phone} · {f.customer_id}</span></p>
              <p className="text-xs text-zinc-400">{(f.students || []).join(" + ")} · {f.amount} · 1er prélèvement le {f.deadline}</p>
            </div>
            <span className="text-xs font-semibold" data-testid={`card-followup-status-${f.id}`}>
              {f.done ? `✅ Carte réenregistrée •••• ${f.live?.card_last4}${f.live?.card_registered_at ? " le " + String(f.live.card_registered_at).slice(0, 10) : ""}`
                : f.live?.error ? `⚠️ Stripe injoignable : ${f.live.error}`
                : `⏳ Pas encore — mode de paiement actuel : ${f.live?.default_type || "aucun"} · ${f.days_left >= 0 ? `J-${f.days_left}` : `${-f.days_left} j de retard`}`}
            </span>
          </div>
          {!f.done && (
            <div className="mt-2 flex flex-wrap items-center gap-2 text-xs">
              <button onClick={() => remind(f, "sms")} disabled={!!busy} className="px-3 py-1.5 rounded bg-[#D90429] hover:bg-rose-700 text-white font-semibold disabled:opacity-40" data-testid={`card-followup-remind-${f.id}`}>{busy === f.id + "sms" ? "Envoi…" : "📱 Relancer par SMS maintenant"}</button>
              <button onClick={() => remind(f, "preview")} disabled={!!busy} className="px-3 py-1.5 rounded border border-zinc-700 text-zinc-300 hover:bg-zinc-800 disabled:opacity-40" data-testid={`card-followup-preview-${f.id}`}>Voir le texte</button>
              <span className="text-zinc-400">
                {f.last_reminder_at ? `Dernière relance : ${String(f.last_reminder_at).slice(0, 16).replace("T", " ")}` : "Relance SMS du 29 sept. envoyée par E1"}
                {" · "}{f.auto_queued_at ? "relance auto préparée dans la Boîte d'envoi ✓" : `relance auto le ${f.auto_reminder_date} (préparée à 9 h dans « À approuver »)`}
              </span>
            </div>
          )}
          {(f.live?.subscriptions || []).length > 0 && <p className="mt-1 text-[11px] text-zinc-500" data-testid={`card-followup-subs-${f.id}`}>Abonnements : {f.live.subscriptions.map((s) => `${s.id.slice(0, 12)}… ${s.status}${s.trial_end ? " → " + s.trial_end : ""}`).join(" · ")}</p>}
        </div>
      ))}
      {preview && (
        <div className="rounded border border-zinc-700 bg-zinc-950 p-3 text-xs" data-testid="card-followup-preview-text">
          <div className="flex justify-between"><b className="text-zinc-200">Texte du SMS — {preview.name}</b><button onClick={() => setPreview(null)} className="text-zinc-400 hover:text-white">✕</button></div>
          <p className="mt-1 text-zinc-300 whitespace-pre-wrap">{preview.text}</p>
        </div>
      )}
    </div>
  );
}
